import { render, staticRenderFns } from "./PeriodicalBox1.vue?vue&type=template&id=2028ffa9&scoped=true"
import script from "./PeriodicalBox1.vue?vue&type=script&lang=js"
export * from "./PeriodicalBox1.vue?vue&type=script&lang=js"
import style0 from "./PeriodicalBox1.vue?vue&type=style&index=0&id=2028ffa9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2028ffa9",
  null
  
)

export default component.exports